// extracted by mini-css-extract-plugin
module.exports = {"container":"small_title-module--container--JI-hX","title":"small_title-module--title--2epzw","subtitle":"small_title-module--subtitle--3-9jw"};